import { createSlice } from "redux-starter-kit";

export const analystDirectorySlice = createSlice({
  slice: "analystDirectory",
  initialState: { filter: {}, sort: { field: "LastName_en", value: "asc" }, page: 1, pageSize: 20 },
  reducers: {
    setFilter: (state, action) => {
      const { key, value } = action.payload;
      state.filter[key] = value;
      state.page = 1;
    },
    toggleSort: (state, action) => {
      const { field } = action.payload;
      const currentValue = state.sort.value;

      state.sort.field = field;
      if (!currentValue || currentValue === "desc") {
        state.sort.value = "asc";
      } else {
        state.sort.value = "desc";
      }
    },
    setPage: (state, action) => {
      const { page } = action.payload;
      state.page = page;
    },
  },
});
